import React, { useContext, useEffect, useState } from 'react';
import { Dimensions, ScrollView, View } from 'react-native';
import Modal from 'modal-enhanced-react-native-web';
import { GiphyFetch } from '@giphy/js-fetch-api'
const gf = new GiphyFetch('MPKLmL5j0G3TesyhtNeDTE0nZ3F8CKCB')

const { width } = Dimensions.get('screen');
import {
    Grid, // our UI Component to display the results
    SearchBar, // the search bar the user will type into
    SearchContext, // the context that wraps and connects our components
    SearchContextManager, // the context manager, includes the Context.Provider
    SuggestionBar, // an optional UI component that displays trending searches and channel / username results
} from '@giphy/react-components'
import Colors from '../../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../../globalComponents/NativeOverrides';

// the search experience consists of the manager and its child components that use SearchContext
type GifySelectBoxType = { isVisible:boolean, gifSelect:any, closeModal:any }
const GifySelectBox = ({ isVisible, gifSelect, closeModal }:GifySelectBoxType) => {
    if(!isVisible){ return (<></>) }
    return (
        <Modal isVisible={isVisible} style={{ flex:1, margin:0, marginTop:100, justifyContent: 'flex-end', alignItems:'center'}} animationIn='slideInUp' animationOut='slideOutDown' animationOutTiming={400}
        onSwipeComplete={() => closeModal()} onBackdropPress={() => closeModal()} >
            <View style={{flex:1, width:width>800?800:width}}>
                <ScrollView style={{flex:1, backgroundColor:Colors.shades.white, paddingTop:10, borderTopRightRadius:2, borderTopLeftRadius:2}}>
                    <SearchContextManager apiKey={'MPKLmL5j0G3TesyhtNeDTE0nZ3F8CKCB'}>
                        <Components gifSelect={gifSelect} />
                    </SearchContextManager>
                </ScrollView>
                <View style={{backgroundColor:Colors.shades.white}}>
                    <TouchableOpacity style={{ margin:10, borderRadius:4, borderWidth:1, borderColor:Colors.brand.midnight }} onPress={() => closeModal()}>
                        <Text color={Colors.brand.midnight} size={14} weight='semibold'>CLOSE</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </Modal>
           
        
    )
}

// define the components in a separate function so we can
// use the context hook. You could also use the render props pattern
const Components = ({ gifSelect }: { gifSelect:any }) => {
    const { fetchGifs, searchKey } = useContext(SearchContext)
    const [ initGifs, setInitGifs ] = useState()
    useEffect(() => {
        getInitGifs()
    },[])
    const getInitGifs = async() => {
        const fetchedGifs = await gf.trending({ offset: 0, limit: 10 })
        setInitGifs(fetchedGifs.data)
    }

    if(!initGifs){ return (<></>) }
    return (
        <>
            <SearchBar />
            <View style={{paddingTop:10, paddingLeft:2}}>
                <SuggestionBar />
                <Grid noLink onGifClick={(gif) => gifSelect(gif)} initialGifs={searchKey===''?initGifs:[]} key={searchKey} columns={3} width={width>800?800:width} fetchGifs={fetchGifs} />
            </View>
        </>
    )
}


const areEqual = (prevProps:GifySelectBoxType, nextProps:GifySelectBoxType) => {
    let allEqual = true
    if(prevProps.isVisible !== nextProps.isVisible){ return false }
    return allEqual
}

export default React.memo(GifySelectBox, areEqual)



